import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wedialog_footer" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("确定")

import { computed, reactive, ref, unref } from 'vue';
  import { required } from '@/utils/validate';
  import { copyObjectToReactive } from '@/utils/common';

  interface Props {
    columns: Recordable[];
    visible: boolean;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    columns: { default: () => [] },
    visible: { default: false }
  },
  emits: ['change', 'update:visible', 'column_change'],
  setup(__props: any, { emit }) {

const props = __props as { columns: Recordable[], visible: boolean }

  
  
  const form_model = reactive<Recordable>({
    echart_type: 'line',
    x_axis_field: undefined,
    y_axis_fields: [],
    pie_field: undefined,
  });
  const table_chart_modal_form_ref = ref<Nullable<FormActionType>>(null);
  const x_axis_items = computed<Recordable>(() => {
    return props.columns.map((item) => ({
      id: item.dataIndex,
      name: item.title,
      disabled: unref(form_model).y_axis_fields.includes(item.dataIndex),
    }));
  });
  const y_axis_items = computed<Recordable>(() => {
    return props.columns.map((item) => ({
      id: item.dataIndex,
      name: item.title,
      disabled: unref(form_model).x_axis_field === item.dataIndex,
    }));
  });
  const echart_type_items = ref([
    { id: 'line', name: '折线图' },
    { id: 'bar', name: '柱状图' },
    { id: 'pie', name: '饼图' },
  ]);
  const $visible = computed({
    set(val) {
      emit('update:visible', val);
      emit('change', val);
    },
    get() {
      return props.visible;
    },
  });
  const confirm = async () => {
    await unref(table_chart_modal_form_ref)!.validate();
    const x_axis = props.columns.find((x) => x.dataIndex === unref(form_model).x_axis_field);
    const y_axises = props.columns.filter((x) => unref(form_model).y_axis_fields.includes(x.dataIndex));
    const pie_field = props.columns.find((x) => x.dataIndex === unref(form_model).pie_field);
    const data = {
      x_axis,
      y_axises,
      pie_field,
      echart_type: unref(form_model).echart_type,
    };
    emit('column_change', data);
    $visible.value = false;
  };
  const after_close = () => {
    copyObjectToReactive(form_model, {
      x_axis_field: undefined,
      y_axis_fields: [],
      echart_type: 'line',
      pie_field: undefined,
    });
    $visible.value = false;
  };

return (_ctx: any,_cache: any) => {
  const _component_we_select = _resolveComponent("we-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _unref($visible),
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_isRef($visible) ? ($visible).value = $event : null)),
    centered: "",
    closable: false,
    maskClosable: "",
    wrapClassName: "we-dialog_container",
    afterClose: after_close
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($visible.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: (_value, _refs) => {
          _refs['table_chart_modal_form_ref'] = _value
          table_chart_modal_form_ref.value = _value
        },
        model: _unref(form_model),
        labelCol: { style: 'width: 80px' },
        wrapperCol: { style: 'max-width: calc(100% - 80px)' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "图表类型",
                    name: "echart_type",
                    rules: [_unref(required)()]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_we_select, {
                        value: _unref(form_model).echart_type,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form_model).echart_type) = $event)),
                        options: echart_type_items.value
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["rules"])
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "横坐标",
                    name: "x_axis_field",
                    rules: _unref(form_model).echart_type !== 'pie' ? [_unref(required)()] : []
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_we_select, {
                        value: _unref(form_model).x_axis_field,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form_model).x_axis_field) = $event)),
                        options: _unref(x_axis_items)
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["rules"])
                ]),
                _: 1
              }, 512), [
                [_vShow, _unref(form_model).echart_type !== 'pie']
              ]),
              _withDirectives(_createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "纵坐标",
                    name: "y_axis_fields",
                    rules: _unref(form_model).echart_type !== 'pie' ? [_unref(required)()] : []
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_we_select, {
                        value: _unref(form_model).y_axis_fields,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form_model).y_axis_fields) = $event)),
                        options: _unref(y_axis_items),
                        mode: "multiple"
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["rules"])
                ]),
                _: 1
              }, 512), [
                [_vShow, _unref(form_model).echart_type !== 'pie']
              ]),
              _withDirectives(_createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "维度",
                    name: "pie_field",
                    rules: _unref(form_model).echart_type === 'pie' ? [_unref(required)()] : []
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_we_select, {
                        value: _unref(form_model).pie_field,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form_model).pie_field) = $event)),
                        options: _unref(x_axis_items)
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["rules"])
                ]),
                _: 1
              }, 512), [
                [_vShow, _unref(form_model).echart_type === 'pie']
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "wrapperCol"])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})